import React from "react";
import styles from "./ServerError.module.scss";
const ServerErrorPage = () => {
  return (
    <div className={styles.errorContainer}>
      <h1 className={styles.errorCode}>500</h1>
      <p className={styles.errorMessage}>Axtardığınız səhifə tapılmadı</p>
    </div>
  );
};

export default ServerErrorPage;
